export default defineNuxtRouteMiddleware(async (to) => {
  switch (to.path) {
    case '/signin':
    case '/signup':
      return navigateTo('/', { replace: true })
    default:
      break
  }
})
